module.exports = __webpack_public_path__ + "img/tutorial08.eae14a7a.png";